import { render, staticRenderFns } from "./zxglve.vue?vue&type=template&id=5250ff03&scoped=true&"
import script from "./zxglve.vue?vue&type=script&lang=js&"
export * from "./zxglve.vue?vue&type=script&lang=js&"
import style0 from "./zxglve.vue?vue&type=style&index=0&id=5250ff03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5250ff03",
  null
  
)

export default component.exports